import React from 'react'
import {
  Panel,
  DataListHeader,
  DataListRow,
  GridCell,
  Grid,
  Text,
  DataListExtraColumn,
  TruncateAndTooltip,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'
import { sendListState } from '../recoil/states/page'
import { initCallback } from '../recoil/callbacks/callbacks'
import ProgressBar from './ProgressBar'
import Status from './Status'
import Date from './Date'
import ActionMenu from './ActionMenu'
import styled from '@emotion/styled'

const SendList = () => {
  const intl = useIntl()
  const EXTRA_COLUMN_ACTION_MENU_AFTER_WIDTH = '30px'
  const init = useRecoilCallback(initCallback, [])
  const [
    { orderBy, orderDescending, items, loading, isEmptyState },
    setListState
  ] = useRecoilState(sendListState)

  const handleChangeColumnsOrder = field => {
    setListState(prev => ({
      ...prev,
      orderBy: field,
      orderDescending: !prev.orderDescending
    }))
    init()
  }

  const heads = [
    {
      field: 'message',
      label: intl.formatMessage({
        id: 'Load.Rcs.SendStatusTableHeadMessage'
      }),
      span: 3,
      sortable: false
    },
    {
      field: 'State',
      label: intl.formatMessage({
        id: 'Load.Rcs.SendStatusTableHeadStatus'
      }),
      span: 3,
      sortable: true
    },
    {
      field: 'UpdateDate',
      label: intl.formatMessage({
        id: 'Load.Rcs.SendStatusTableHeadLastUpdate'
      }),
      span: 3,
      sortable: true
    },
    {
      field: 'progress',
      label: intl.formatMessage({
        id: 'Load.Rcs.SendStatusTableHeadProgress'
      }),
      span: 3,
      sortable: false
    }
  ]
  return (
    <>
      <Panel>
        {isEmptyState && (
          <StyledText variant='light'>
            {intl.formatMessage({
              id: 'Load.Rcs.SendStatusEmptyStateText'
            })}
          </StyledText>
        )}
        {!isEmptyState && (
          <>
            <DataListHeader
              heads={heads}
              afterWidth={EXTRA_COLUMN_ACTION_MENU_AFTER_WIDTH}
              orderByStatus={orderBy}
              orderDescendingStatus={orderDescending}
              handleChangeColumnsOrderCallback={handleChangeColumnsOrder}
            />
            {!loading && (
              <div>
                {items.map(item => (
                  <DataListRow key={item.IdScheduledSending}>
                    <Grid cols={12}>
                      <GridCell span={heads[0].span}>
                        <Text variant='bold'>
                          <TruncateAndTooltip text={item.MessageName} />
                        </Text>
                      </GridCell>
                      <GridCell span={heads[1].span}>
                        <Status
                          state={item.State}
                          scheduleDate={item.ScheduleDate}
                          UITimezone={item.UITimezone}
                        />
                      </GridCell>
                      <GridCell span={heads[2].span}>
                        <Date date={item.UpdateDate} />
                      </GridCell>
                      <GridCell span={heads[3].span}>
                        <ProgressBar
                          progressPerc={item.ProgressPerc}
                          state={item.State}
                          progress={item.ProgressPartial}
                          total={item.ProgressTotal}
                        />
                      </GridCell>
                    </Grid>
                    <DataListExtraColumn
                      after
                      width={EXTRA_COLUMN_ACTION_MENU_AFTER_WIDTH}
                    >
                      <ActionMenu item={item} />
                    </DataListExtraColumn>
                  </DataListRow>
                ))}
              </div>
            )}
            {loading && (
              <div>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => (
                  <DataListRow key={item}>
                    <Grid cols={12}>
                      <GridCell span={heads[0].span}>
                        <SkeletonLoader
                          variant={SKELETON_LOADER_VARIANT_ONWHITE}
                        />
                      </GridCell>
                      <GridCell span={heads[1].span}>
                        <SkeletonLoader
                          variant={SKELETON_LOADER_VARIANT_ONWHITE}
                        />
                      </GridCell>
                      <GridCell span={heads[2].span}>
                        <SkeletonLoader
                          variant={SKELETON_LOADER_VARIANT_ONWHITE}
                        />
                      </GridCell>
                      <GridCell span={heads[3].span}>
                        <SkeletonLoader
                          variant={SKELETON_LOADER_VARIANT_ONWHITE}
                        />
                      </GridCell>
                    </Grid>
                    <DataListExtraColumn
                      after
                      width={EXTRA_COLUMN_ACTION_MENU_AFTER_WIDTH}
                    />
                  </DataListRow>
                ))}
              </div>
            )}
          </>
        )}
      </Panel>
    </>
  )
}

export default SendList

const StyledText = styled(Text)`
  text-align: center;
`
